<!--
 * @Author: wangkai 1148506760@qq.com
 * @Date: 2023-01-15 11:19:40
 * @LastEditors: wangkai 1148506760@qq.com
 * @LastEditTime: 2023-02-01 14:35:26
 * @FilePath: \hallportal-web\pc\src\views\management\systemConfig\systemConfig.vue
 * @Description: 系统配置背景背景图、单点登录开关、登录地址、退出地址
-->
<template>
  <div class="systemConfig">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="name" label="参数名" width="300">
      </el-table-column>
      <el-table-column prop="value" label="当前值" width="300">
        <template slot-scope="scope">
          <el-input
            v-if="scope.row.type == '0'"
            v-model="scope.row.value"
          ></el-input>
          <el-upload
            v-if="scope.row.type == '3'"
            class="avatar-uploader"
            action="#"
            :before-remove="beforeRemove"
            :before-upload="beforeUpload"
          >
            <img v-if="iconUrl" :src="iconUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-upload
            v-if="scope.row.type == '1'"
            class="avatar-uploader"
            action=""
            :before-remove="beforeRemoveLogo"
            :before-upload="beforeUploadlogo"
          >
            <img
              v-if="imageUrl"
              :src="imageUrl"
              class="avatar"
              style="width: 200px"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-select
            v-model="scope.row.value"
            placeholder="请选择"
            v-if="scope.row.type == '2'"
          >
            <el-option
              v-for="item in scope.row.values"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="edit(scope.row)">保存</el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getSystemConfig, updateSystemConfig } from "@/api/management/system";
import { getLoginConfig } from "@/api/login";
import { sysFileUpload } from "@/api/managementCenter/otherApi";
export default {
  data() {
    return {
      form: {
        logo_text: "",
        favicon: "",
        copyright_info: "",
        logo: "",
        ssoLogin: "",
        ssoLogout: "",
        isOpenCassso: false,
        middlePage: false,
        phone: false,
        mobileOrPc: false,
        mobileUrl: "",
        pcUrl: "",
      },
      tableData: [],
      fileList: [],
      imageUrl: "",
      logoList: [],
      iconUrl: "",
    };
  },
  mounted() {
    this.getSystemConfigInfo();
  },
  methods: {
    async getSystemConfigInfo() {
      const { data } = await getSystemConfig();
      if (data.success) {
        this.tableData = data.data;
        this.tableData.forEach(i => {
          if (i.values) {
            i.values = JSON.parse(i.values);
          }
          //图标回显
          if (i.type == "3" && i.value) {
            this.iconUrl = i.value;
          }
          //logo回显
          if (i.type == "1" && i.value != "") {
            this.imageUrl = i.value;
          }
        });
        console.log(this.tableData);
      }
    },
    async edit(val) {
      var obj = JSON.parse(JSON.stringify(val));
      if (obj.values != "") {
        obj.values = JSON.stringify(val.values);
      }
      const res = await updateSystemConfig(obj);
      if (res.data.success) {
        this.getLoginConfig();
        this.$message.success("保存成功!");
      } else {
        this.$message.warning(res.data.msg || "保存失败!");
      }
    },

    async getLoginConfig() {
      let res = await getLoginConfig();
      res.data.data.isOpenCassso == "1"
        ? (res.data.data.isOpenCassso = true)
        : (res.data.data.isOpenCassso = false);
      res.data.data.middlePage == "1"
        ? (res.data.data.middlePage = true)
        : (res.data.data.middlePage = false);
      res.data.data.phone == "1"
        ? (res.data.data.phone = true)
        : (res.data.data.phone = false);
      res.data.data.mobileOrPc == "1"
        ? (res.data.data.mobileOrPc = true)
        : (res.data.data.mobileOrPc = false);
      window.sessionStorage.setItem("setConfig", JSON.stringify(res.data.data));
      let faviconLink = document.querySelector("#faviconLink");
      if (faviconLink) {
        faviconLink.setAttribute("href", res.data.data.favicon);
      }
    },
    beforeRemove(file, fileList) {
      this.fileList = fileList;
    },
    beforeUpload(file) {
      this.fileList = [];
      const isICON = file.type === "image/x-icon";
      if (!isICON) {
        this.$message.error("上传图标只能是icon格式!");
        return;
      }
      let fd = new FormData();
      fd.append("file", file);
      sysFileUpload(fd).then(({ data }) => {
        console.log(data);
        if (data.success) {
          this.iconUrl = data.data.url;
          this.tableData.forEach(i => {
            if (i.type == "3") {
              i.value = data.data.url;
            }
          });
          this.$message.success("上传成功!");
        } else {
          this.$message.warning(data.msg || "上传失败!");
        }
      });
    },
    //学院logo
    beforeUploadlogo(file) {
      this.imageUrl = "";
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传图标只能是JPG/PNG格式!");
        return;
      }
      let fd = new FormData();
      fd.append("file", file);
      sysFileUpload(fd).then(({ data }) => {
        console.log(data);
        if (data.success) {
          this.imageUrl = data.data.url;
          this.tableData.forEach(i => {
            if (i.type == "1") {
              i.value = data.data.url;
            }
          });
          this.$message.success("上传成功!");
        } else {
          this.$message.warning(data.msg || "上传失败!");
        }
      });
    },
    beforeRemoveLogo() {},
  },
};
</script>
<style scoped lang="less">
.systemConfig {
  width: 100%;
  padding: 20px;
  height: 100%;
}
</style>
